module.exports=[
  {
    "index": 34,
    "name": "Aaman Ali",
    "age": 13,
    "location": "Brooklyn, New York",
    "type": "basic",
    "story": "Things need to change. This helps."
  },
  {
    "index": 20,
    "name": "Jada Anderson",
    "age": 11,
    "location": "Detroit, Michigan",
    "type": "basic",
    "story": "These events make me feel powerful."
  },
  {
    "index": "FP8",
    "name": "Finley Williams",
    "age": 17,
    "location": "Chicago, Illinois",
    "type": "first-person",
    "story": "I am proud we flooded the streets. But it’s too soon to celebrate.",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://chicago.chalkbeat.org/2020/6/25/21303059/chicago-student-i-am-proud-we-flooded-the-streets-but-its-too-soon-to-celebrate",
    "headshot": "finley-williams",
    "button_language": "Read her story"
  },
  {
    "index": "65A",
    "name": "Gisselle Dominguez",
    "age": 18,
    "location": "Waukesha, Wisconsin",
    "type": "art",
    "story": "If I said, “I can’t breathe.”",
    "file_name": "gisselle-dominguez-1",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 4,
    "name": "Allison Martinez",
    "age": 12,
    "location": "Los Angeles, California",
    "type": "basic",
    "story": "Confused, hurt, angry, disappointed, shocked, unsafe."
  },
  {
    "index": 23,
    "name": "Abdelhamid Arbab",
    "age": 17,
    "location": "North Arlington, New Jersey",
    "type": "basic",
    "story": "Radical reconstruction — constant, creative, and ancestral."
  },
  {
    "index": 6,
    "name": "Abigail Weaver",
    "age": 17,
    "location": "Greeley, Colorado",
    "type": "basic",
    "story": "Our generation is intolerant of injustice."
  },
  {
    "index": 32,
    "name": "Beckett Birch Sirignano",
    "age": 9,
    "location": "New York, New York",
    "type": "audio",
    "story": "I want to cry and shout.",
    "file_name": "beckett-birch-sirignano"
  },
  {
    "index": 59,
    "name": "Kaleb Sy",
    "age": 15,
    "location": "Memphis, Tennessee",
    "type": "basic",
    "story": "Angry, emotional, overwhelmed, positive, hopeful, practical."
  },
  {
    "index": "B",
    "name": "Erika Orellana",
    "age": 16,
    "location": "Corona, New York",
    "type": "art",
    "story": "",
    "file_name": "erika-orellana",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": "TT1",
    "name": "Makyah Thomas-Malone",
    "age": "",
    "location": "",
    "type": "twitter-thread",
    "story": "",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://twitter.com/Chalkbeat/status/1275057347702878215",
    "headshot": "makyah-thomas-malone",
    "button_language": "Read her Twitter takeover"
  },
  {
    "index": "FP9",
    "name": "Andrea Saldana",
    "age": 18,
    "location": "San Jose, California",
    "type": "first-person",
    "story": "Here’s what I learned reporting on antiracism protests for my school newspaper",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://www.chalkbeat.org/2020/6/26/21303071/heres-what-i-learned-reporting-on-antiracism-protests-for-my-school-newspaper",
    "headshot": "andrea-saldana",
    "button_language": "Read her story"
  },
  {
    "index": 12,
    "name": "Camden Young",
    "age": 10,
    "location": "Lansing, Illinois",
    "type": "audio",
    "story": "Sad, upset, angry, killing, unprotected, lawless.",
    "file_name": "camden-young"
  },
  {
    "index": 62,
    "name": "Ayaka Pier",
    "age": 14,
    "location": "Renton, Washington",
    "type": "art",
    "story": "How long till our suffering ends?",
    "file_name": "ayaka-pier",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 8,
    "name": "Angie Michel",
    "age": 14,
    "location": "Frederick, Colorado",
    "type": "basic",
    "story": "I feel tired and fired up."
  },
  {
    "index": 58,
    "name": "Bria Latson",
    "age": 17,
    "location": "Memphis, Tennessee",
    "type": "basic",
    "story": "Until Black lives matter, we march."
  },
  {
    "index": "49B",
    "name": "Grace Samuels",
    "age": 14,
    "location": "New York, New York",
    "type": "art-audio",
    "story": "Original song: Left in a cloud of smoke",
    "file_name": "grace-samuels-2",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 27,
    "name": "Amal Khateeb",
    "age": 17,
    "location": "Bergenfield, New Jersey",
    "type": "basic",
    "story": "Use your privilege. Be an ally."
  },
  {
    "index": 21,
    "name": "Dashawn Sheffield",
    "age": 15,
    "location": "Newark, New Jersey",
    "type": "basic",
    "story": "Today's protests might increase American democracy."
  },
  {
    "index": 18,
    "name": "Destiny Jenkins-Jones",
    "age": 17,
    "location": "Detroit, Michigan",
    "type": "basic",
    "story": "Every ethnic group will be equal."
  },
  {
    "index": 19,
    "name": "Roniya Tinnon",
    "age": 13,
    "location": "Detroit, Michigan",
    "type": "basic",
    "story": "They're taking the badge for granted."
  },
  {
    "index": 5,
    "name": "Addison Burgett",
    "age": 17,
    "location": "Denver, Colorado",
    "type": "basic",
    "story": "They have allowed me to learn."
  },
  {
    "index": 64,
    "name": "Brenna Koester",
    "age": 14,
    "location": "Trout Lake, Washington",
    "type": "art",
    "story": "Change does not come from comfort.",
    "file_name": "brenna-koester",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": "FP6",
    "name": "Shania Leila Brace",
    "age": 17,
    "location": "Denver, Colorado",
    "type": "first-person",
    "story": "Turning fear into power",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://co.chalkbeat.org/2020/6/24/21299175/student-takeover-fear-into-power",
    "headshot": "shania-leila-brace",
    "button_language": "Read her story"
  },
  {
    "index": 37,
    "name": "Giancarlo Herrera",
    "age": 18,
    "location": "New York, New York",
    "type": "basic",
    "story": "Civil rights called. The people answered."
  },
  {
    "index": 51,
    "name": "Jacob Fenton",
    "age": 16,
    "location": "Vandalia, Ohio",
    "type": "basic",
    "story": "Make the whole country equal again."
  },
  {
    "index": "65B",
    "name": "Gisselle Dominguez",
    "age": 18,
    "location": "Waukesha, Wisconsin",
    "type": "art",
    "story": "",
    "file_name": "gisselle-dominguez-2",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 67,
    "name": "Jasmine Sosa",
    "age": 14,
    "location": "New York, New York",
    "type": "basic",
    "story": "We are the change we want."
  },
  {
    "index": 24,
    "name": "Grace McLoughlin",
    "age": 9,
    "location": "New Jersey and New York",
    "type": "basic",
    "story": "Standing for what's right makes justice."
  },
  {
    "index": 3,
    "name": "Jenica Jairam",
    "age": 18,
    "location": "Ontario, Canada",
    "type": "basic",
    "story": "Fight till they mend their ways."
  },
  {
    "index": "A",
    "name": "Banetse Gomez",
    "age": 17,
    "location": "Bronx, New York",
    "type": "art",
    "story": "",
    "file_name": "banetse-gomez",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 1,
    "name": "Hayley Barber",
    "age": 16,
    "location": "Pell City, Alabama",
    "type": "basic",
    "story": "Don’t just trim racism; uproot it."
  },
  {
    "index": 31,
    "name": "Jacqueline Pereda",
    "age": 16,
    "location": "Rego Park, New York",
    "type": "art",
    "story": "Justice must be served, no excuses.",
    "file_name": "jacqueline-pereda",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": "FP7",
    "name": "Lamont Satchel Jr.",
    "age": 17,
    "location": "Detroit, Michigan",
    "type": "first-person",
    "story": "We are the change generation",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://detroit.chalkbeat.org/2020/6/25/21300735/antiracism-black-youth-detroit",
    "headshot": "lamont-satchel-jr",
    "button_language": "Read his story"
  },
  {
    "index": 50,
    "name": "A. Shi",
    "age": 13,
    "location": "Brooklyn, New York",
    "type": "basic",
    "story": "We'll change the legacy we've left."
  },
  {
    "index": 22,
    "name": "Jayla Fudge",
    "age": 15,
    "location": "Newark, New Jersey",
    "type": "basic",
    "story": "Tired, fed up, alarmed, startled, confused."
  },
  {
    "index": 66,
    "name": "Isabel Schryver",
    "age": 18,
    "location": "Madison, Wisconsin",
    "type": "basic",
    "story": "Our democracy has never been real."
  },
  {
    "index": 11,
    "name": "Aynsleigh Wood",
    "age": 16,
    "location": "Ouray, Colorado",
    "type": "basic",
    "story": "Ashamed, proud, scared, enraged, and hopeful."
  },
  {
    "index": 46,
    "name": "Kangkhita Kaes",
    "age": 17,
    "location": "East Elmhurst, New York",
    "type": "basic",
    "story": "Rightfully enraged. A revolution is coming."
  },
  {
    "index": "C",
    "name": "Karen Agyei-Odame",
    "age": 16,
    "location": "New York, New York",
    "type": "art",
    "story": "",
    "file_name": "karen-agyei-odame",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 40,
    "name": "Hannah McKie",
    "age": 15,
    "location": "Brooklyn, New York",
    "type": "basic",
    "story": "Proud of the power and solidarity."
  },
  {
    "index": "49A",
    "name": "Grace Samuels",
    "age": 14,
    "location": "New York, New York",
    "type": "art-audio",
    "story": "Change derived from injustice leads nations.",
    "file_name": "grace-samuels-1",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 47,
    "name": "Kazi Begum",
    "age": 14,
    "location": "Brooklyn, New York",
    "type": "basic",
    "story": "Won't stop till Black lives matter."
  },
  {
    "index": 15,
    "name": "Lanaya George",
    "age": 14,
    "location": "Merrillville, Indiana",
    "type": "basic",
    "story": "Mad, upset, confused, scarred, portrayed, misunderstood."
  },
  {
    "index": "FP5",
    "name": "Josiah Alexander",
    "age": 16,
    "location": "Queens, New York",
    "type": "first-person",
    "story": "Emmett, Kalief, Josiah: More than just names",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://ny.chalkbeat.org/2020/6/24/21300720/student-takeover-solutions-systemic-racism",
    "headshot": "josiah-alexander",
    "button_language": "Read his story"
  },
  {
    "index": 61,
    "name": "Johanna Olvera",
    "age": 18,
    "location": "Memphis, Tennessee",
    "type": "art",
    "story": "Unity is the oppressor’s greatest nightmare.",
    "file_name": "johanna-olvera",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 52,
    "name": "Lauren Randolph",
    "age": 16,
    "location": "Ohio",
    "type": "basic",
    "story": "Only riots work in this country."
  },
  {
    "index": 35,
    "name": "Leann Nicholas",
    "age": 16,
    "location": "Farmingdale, New York",
    "type": "basic",
    "story": "We will never be the same."
  },
  {
    "index": 7,
    "name": "Lily Kerlin",
    "age": 17,
    "location": "Denver, Colorado",
    "type": "basic",
    "story": "A learning experience to push society."
  },
  {
    "index": 2,
    "name": "Masood Syed",
    "age": 18,
    "location": "Ajax, Ontario",
    "type": "basic",
    "story": "For a society in 2020, sad."
  },
  {
    "index": "FP3",
    "name": "Jasin Shiggs",
    "age": 13,
    "location": "Newark, NJ",
    "type": "first-person",
    "story": "I am George Floyd!",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://newark.chalkbeat.org/2020/6/23/21298870/student-takeover-george-floyd",
    "headshot": "jasin-shiggs",
    "button_language": "Read his story"
  },
  {
    "index": 38,
    "name": "Matthew Valdez",
    "age": 18,
    "location": "Bronx, New York",
    "type": "basic",
    "story": "All lives have never mattered here."
  },
  {
    "index": 13,
    "name": "Mateo Curiel",
    "age": 16,
    "location": "Chicago, Illinois",
    "type": "art",
    "story": "Reevaluation for the purpose of repose.",
    "file_name": "mateo-curiel",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View poem"
  },
  {
    "index": 26,
    "name": "Mazin Elshareif",
    "age": 18,
    "location": "Clifton, New Jersey",
    "type": "basic",
    "story": "BLM is not a trend. Change."
  },
  {
    "index": 28,
    "name": "Kelly Shi",
    "age": 14,
    "location": "Brooklyn, New York",
    "type": "art",
    "story": "Powerful way to peacefully protest cruelty.",
    "file_name": "kelly-shi",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 53,
    "name": "Zaynab I.",
    "age": 18,
    "location": "Portland, Oregon",
    "type": "basic",
    "story": "We’ve had enough. Black lives matter."
  },
  {
    "index": 14,
    "name": "Meg Hasch",
    "age": 15,
    "location": "Carmel, Indiana",
    "type": "basic",
    "story": "We need equality, not higher taxation."
  },
  {
    "index": 56,
    "name": "Peighton Cantrell",
    "age": 11,
    "location": "Memphis, Tennessee",
    "type": "art",
    "story": "They died with peace in mind.",
    "file_name": "peighton-cantrell",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View poem"
  },
  {
    "index": 25,
    "name": "Musaab Mahmoud",
    "age": 14,
    "location": "Ridgewood, New Jersey",
    "type": "basic",
    "story": "Terrifying moments that will shape history."
  },
  {
    "index": "FP4",
    "name": "Sophia Perry",
    "age": 17,
    "location": "Chattanooga, Tennessee",
    "type": "first-person",
    "story": "Protesting was empowering. It was also terrifying.",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://tn.chalkbeat.org/2020/6/22/21298930/student-takeover-protesting-empowering",
    "headshot": "sophia-perry",
    "button_language": "Read her story"
  },
  {
    "index": 63,
    "name": "Nathanael Cooper",
    "age": 16,
    "location": "Renton, Washington",
    "type": "audio",
    "story": "I screamed and begged, and still.",
    "file_name": "nathanael-cooper"
  },
  {
    "index": 44,
    "name": "Nazira Cisse",
    "age": 17,
    "location": "Bronx, New York",
    "type": "basic",
    "story": "We're fighting but tired, very tired"
  },
  {
    "index": 54,
    "name": "Novalie Duffy",
    "age": 17,
    "location": "New Tripoli, Pennsylvania",
    "type": "basic",
    "story": "No lives matter until Blacks do."
  },
  {
    "index": 42,
    "name": "Ogechukwu Anene",
    "age": 16,
    "location": "Staten Island, New York",
    "type": "basic",
    "story": "It is either now or never."
  },
  {
    "index": 55,
    "name": "Ommay Farah",
    "age": 17,
    "location": "Nashville, Tennessee",
    "type": "basic",
    "story": "COVID, advocacy, brutality, hope for change."
  },
  {
    "index": "FP2",
    "name": "Hunter and Hudson Russell-Horton",
    "age": 15,
    "location": "New York, New York",
    "type": "first-person",
    "story": "When “do the right thing” means taking to the streets",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://ny.chalkbeat.org/2020/6/22/21297001/when-do-the-right-thing-means-taking-to-the-streets",
    "headshot": "hunter-hudson-russell-horton",
    "button_language": "Read their story"
  },
  {
    "index": "16A",
    "name": "Seynabou Diop",
    "age": 21,
    "location": "Williamstown, Massachusetts",
    "type": "art",
    "story": "Anti-blackness manifests in very different ways.",
    "file_name": "seynabou-diop-1",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 48,
    "name": "Yesenia Lezama",
    "age": 17,
    "location": "New York, New York",
    "type": "basic",
    "story": "Justice shouldn’t be delivered by force."
  },
  {
    "index": 17,
    "name": "Rabab Aljebori",
    "age": 21,
    "location": "Dearborn, Michigan",
    "type": "basic",
    "story": "Angry that hatred like this exists."
  },
  {
    "index": 30,
    "name": "Munaja Mehzabin",
    "age": 16,
    "location": "Astoria, New York",
    "type": "audio",
    "story": "Our system needs to change now.",
    "file_name": "munaja-mehzabin"
  },
  {
    "index": "D",
    "name": "Sarah Glyn-Williams",
    "age": 19,
    "location": "Ajax, Ontario",
    "type": "art",
    "story": "",
    "file_name": "sarah-glyn-williams",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 60,
    "name": "Riaaz Phillips",
    "age": 17,
    "location": "Memphis, Tennessee",
    "type": "basic",
    "story": "Disappointed, scared, infuriated, motivated — my feelings."
  },
  {
    "index": 33,
    "name": "Zaedoen Gyephel",
    "age": 13,
    "location": "New York, New York",
    "type": "basic",
    "story": "Screaming loud, but nobody can hear."
  },
  {
    "index": "FP1",
    "name": "Jayla Hemphill",
    "age": 16,
    "location": "Denver, Colorado",
    "type": "first-person",
    "story": "For my white peers, breathing is easy",
    "file_name": "",
    "art_title": "",
    "art_description": "",
    "url": "https://co.chalkbeat.org/2020/6/21/21296969/for-my-white-peers-breathing-is-easy",
    "headshot": "jayla-hemphill",
    "button_language": "Read her story"
  },
  {
    "index": 29,
    "name": "Ela Uludag",
    "age": 14,
    "location": "Brooklyn, New York",
    "type": "basic",
    "story": "How can people just say nothing?"
  },
  {
    "index": "16B",
    "name": "Seynabou Diop",
    "age": 21,
    "location": "Williamstown, Massachusetts",
    "type": "art",
    "story": "",
    "file_name": "seynabou-diop-2",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 9,
    "name": "Rosselyn Gurrola-Solis",
    "age": 15,
    "location": "Lakewood, Colorado",
    "type": "basic",
    "story": "Let us be peaceful within love."
  },
  {
    "index": 10,
    "name": "Savannah Storms",
    "age": 16,
    "location": "Fountain, Colorado",
    "type": "basic",
    "story": "Don't be silent, end the violence."
  },
  {
    "index": 39,
    "name": "Shadavia Burnett",
    "age": 16,
    "location": "New York",
    "type": "basic",
    "story": "Eye-opening, altering, unsettling, involving, and violated."
  },
  {
    "index": 45,
    "name": "Stevon Gibbons",
    "age": 16,
    "location": "Brooklyn, New York",
    "type": "art",
    "story": "Our strongest weapon is our voices.",
    "file_name": "stevon-gibbons",
    "art_title": "",
    "art_description": "",
    "url": "",
    "headshot": "",
    "button_language": "View art"
  },
  {
    "index": 57,
    "name": "Bryson Cantrell",
    "age": 11,
    "location": "Memphis, Tennessee",
    "type": "basic",
    "story": "Old movement, hopefully with new results."
  },
  {
    "index": 41,
    "name": "Tais Kouznetski",
    "age": 17,
    "location": "Brooklyn, New York",
    "type": "basic",
    "story": "It is not politics, but morals."
  },
  {
    "index": 43,
    "name": "Mckayla Charlemagne",
    "age": 15,
    "location": "Queens, New York",
    "type": "basic",
    "story": "As a student, this is stressful."
  }
]